export default __webpack_public_path__ + "static/media/fatimaNcake_w640.56dab564.jpeg";